import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useCallback } from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import NavList from "./components/NavList";
import NavItem from "./components/NavItem";
import Footer from "./components/Footer";
import SubFooter from "./components/SubFooter";
import classNames from "classnames";
/**
 * `handleNavListChildren` injects the `currentMenu` state and `handleItemClick` handler
 */

var handleNavListChildren = function handleNavListChildren(children, currentMenu, _handleItemClick) {
  return React.Children.map(children, function (child, index) {
    var props = child.props,
        type = child.type;

    if (type === Footer || type === SubFooter) {
      return null;
    }
    /**
     * inject `isExpanded` and `handleItemClick` into `NavList` children
     * having uniqueId for each menu item to handle the state of the menu being expanded efficiently
     */


    var uniqueId = "".concat(props === null || props === void 0 ? void 0 : props.title, "-").concat(index);

    if (type === NavList) {
      return /*#__PURE__*/React.cloneElement(child, {
        isExpanded: currentMenu === uniqueId,
        handleItemClick: function handleItemClick() {
          return _handleItemClick(uniqueId);
        }
      });
    }
    /**
     * if it is a fragment and the props have children then handle those children
     */


    if (type === React.Fragment && props.children) {
      return /*#__PURE__*/React.cloneElement(child, {
        children: handleNavListChildren(props.children, currentMenu, _handleItemClick)
      });
    }

    return child;
  });
};

var handleFooterChildren = function handleFooterChildren(children, currentMenu, handleItemClick) {
  var items = [];
  React.Children.forEach(children, function (child) {
    var type = child.type;

    if (type === Footer) {
      items.push( /*#__PURE__*/React.cloneElement(child, {
        isExpanded: currentMenu === "logo",
        handleItemClick: handleItemClick
      }));
    }
  });
  return items;
};

var handleSubFooterChildren = function handleSubFooterChildren(children) {
  var items = [];
  React.Children.forEach(children, function (child) {
    var type = child.type;

    if (type === SubFooter) {
      items.push(child);
    }
  });
  return items;
};

var SiteFooter = function SiteFooter(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(SiteFooter.displayName);

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      currentMenu = _useState2[0],
      setCurrentMenu = _useState2[1];

  var handleItemClick = function handleItemClick(menuId) {
    if (menuId === currentMenu) {
      setCurrentMenu("");
      return;
    }

    setCurrentMenu(menuId);
  };

  var getElementHeightWithoutPadding = function getElementHeightWithoutPadding(element) {
    var _getComputedStyle = getComputedStyle(element),
        paddingBottom = _getComputedStyle.paddingBottom;

    var paddingBottomValue = parseInt(paddingBottom);
    var height = element.offsetHeight - paddingBottomValue;
    return height;
  };

  var recalculateNodePadding = useCallback(function () {
    var headerNodes = Array.from(document.querySelectorAll(".emcmUi-SiteFooterNavList-desktopShow"));
    var maxHeight = Math.max.apply(Math, _toConsumableArray(headerNodes.map(getElementHeightWithoutPadding)));
    headerNodes.forEach(function (node) {
      var nodeHeight = getElementHeightWithoutPadding(node);

      if (nodeHeight < maxHeight) {
        node.style.paddingBottom = "".concat(maxHeight - nodeHeight, "px");
      } else {
        node.style.paddingBottom = "0";
      }
    });
  }, [window.screen.width]);
  useEffect(function () {
    var customDocument = document;

    if (customDocument.fonts && customDocument.fonts.ready) {
      customDocument.fonts.ready.then(function () {
        recalculateNodePadding();
      });
    }

    window.addEventListener("resize", recalculateNodePadding);
    return function () {
      window.removeEventListener("resize", recalculateNodePadding);
    };
  }, [recalculateNodePadding]);
  var footerChildren = handleFooterChildren(children, currentMenu, handleItemClick);
  var navList = handleNavListChildren(children, currentMenu, handleItemClick);
  var subFooterChildren = handleSubFooterChildren(children);
  var isExtended = footerChildren.length > 0 || subFooterChildren.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      states: classNames({
        extended: isExtended
      })
    }),
    "data-rehydratable": getRehydratableName(SiteFooter.displayName)
  }, (navList === null || navList === void 0 ? void 0 : navList.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, /*#__PURE__*/React.createElement("nav", {
    className: getClassName({
      descendantName: "lists"
    }),
    "aria-label": "footer"
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "listsInner"
    })
  }, navList))), footerChildren, subFooterChildren);
};

SiteFooter.defaultProps = {
  isRehydrating: false
};
SiteFooter.displayName = "SiteFooter";
SiteFooter.NavList = NavList;
SiteFooter.NavItem = NavItem;
SiteFooter.Footer = Footer;
SiteFooter.SubFooter = SubFooter;
export default SiteFooter;